export const updateEnviromentAction = (state) => {
  return {
    type: "UPDATE_STATE_ENVIROMENT",
    payload: state,
  };
};
